<template>

    <form id="createbooking" @submit.prevent="onSubmit()">

        <p v-if="errors.MAX_BOOKINGS_REACHED" class="error">{{ errors.MAX_BOOKINGS_REACHED }}</p>
        <p v-if="errors.NOT_PUBLIC" class="error">{{ errors.NOT_PUBLIC }}</p>

        <fieldset class="input-group">
            <div>
                <label for="resource">Lokale</label>
                <p style="margin: 0;"><strong style="font-size: larger;">{{ resource.name }}</strong></p>
                <p>{{ resource.admin_unit_name }}</p>
            </div>
            <div>
                <input id="resource" type="hidden" :value="resource.name" required readonly>
                <button @click.prevent="changeResource()">
                    <template v-if="resource">
                        Vælg et andet lokale
                    </template>
                    <template v-else>
                        Vælg et lokale
                    </template>
                </button>
            </div>
        </fieldset>

        <fieldset>
            <label for="title">Titel på reservation</label>
            <input 
                id="title" 
                type="text" 
                v-model="title" 
                required 
                @change="changeTitle(title)" 
                placeholder="Angiv en titel til din reservation" 
                minlength="3"
                title="Angiv en sigende titel">
        </fieldset>

        <fieldset>
            <label for="date">Dato</label>
            <p v-if="errors.BOOKING_TOO_FAR_IN_THE_FUTURE" class="error">{{ errors.BOOKING_TOO_FAR_IN_THE_FUTURE }}</p>
            <p v-if="errors.BUFFER_REQUIREMENT_NOT_MET" class="error">{{ errors.BUFFER_REQUIREMENT_NOT_MET }}</p>
            <div class="input-group">
                <input id="date" required type="text" :value="pretty_startdate" placeholder="Vælg en startdato" @click="changeStartDate()">
            </div>
        </fieldset>

        <p v-if="errors.NOT_AVAILABLE" class="error">{{ errors.NOT_AVAILABLE }}</p>

        <fieldset>
            <schedule :three-day-rule="limitations.approvalrequirement && !user.is_staff ? true : false" />
        </fieldset>

        <fieldset>
            <duration :max="limitations.limit_duration" :error-msg="errors.BOOKING_TOO_LONG" />
        </fieldset>

        <fieldset v-if="limitations.approvalrequirement">
            <label for="purpose">Formål</label>
            <p class="formhelp">
                Vi beder dig om ikke at skrive om CPR-nummer, følsomme persondata eller andre tilsvarende oplysninger i dette felt.
            </p>
            <p v-if="errors.DESCRIPTION_REQUIRED" class="error">{{ errors.DESCRIPTION_REQUIRED }}</p>
            <textarea id="purpose" v-model="text" :required="!user.is_staff" placeholder="Beskriv hvad du skal bruge lokalet til" @change="changePurpose(text)"></textarea>
            <p v-if="user.is_staff && resource.extras">
                <strong>{{ resource.extras }}</strong>
            </p>
        </fieldset>

        <input type="submit" value="Reservér lokale">
        <a href="#/search" class="btn" @click="clear()" style="margin-left: .5rem;">Annullér</a>
        
    </form>

</template>

<script>

    import axios from '../../utils/Http.js'
    import notify from '../../utils/notify/Notify.js'
    import router from '../../router.js'
    import { dateJs2django, leadZero, displayJSDate } from '../../utils/Filters.js'
    import duration from './Duration.vue'
    import schedule from './Schedule.vue'

    export default {
        components: {
            duration,
            schedule
        },
        data: function () {
            return {
                title: null,
                text: null,
                errors: {},
                limitations: {
                    approvalrequirement: false,
                    limit_duration: false
                }
            }
        },
        computed: {
            user: function() {
                return this.$store.getters.getUser
            },
            resource: function() {
                return this.$store.getters.getResource
            },
            startdatetime: function() {
                return this.$store.getters.getStartDateTime
            },
            pretty_startdate: function() {
                if (!this.startdatetime) {
                    return ''
                }
                return displayJSDate(this.startdatetime)
            },
            duration: function() {
                return this.$store.getters.getDuration
            },
            booking_title: function() {
                return this.$store.getters.getTitle
            },
            purpose: function() {
                return this.$store.getters.getPurpose
            }
        },
        watch: {
            booking_title: function() {
                this.title = this.booking_title
            },
            purpose: function() {
                this.text = this.purpose
            },
            resource: function() {
                this.fetchResourceTypeInfo()
            }
        },
        methods: {
            changeResource: function() {
                router.push('/search')
            },
            changeStartDate: function() {
                if (this.limitations.approvalrequirement && !this.user.is_staff) {
                    // Because limitations, we hardcode that the minimum pickable date should be at least three days from now
                    const in_three_days = new Date().getTime() + 259200000
                    router.push(`/search/calendar/?from=${ in_three_days }`)
                } else {
                    router.push('/search/calendar/')
                }
            },
            changePurpose: function(txt) {
                this.$store.commit('setPurpose', txt)
            },
            changeTitle: function(txt) {
                this.$store.commit('setTitle', txt)
            },
            clear: function() {
                this.$store.commit('clearState')
            },
            prettyZero: function(x) {
                return leadZero(x)
            },
            onSubmit: function() {
                if (!this.resource || !this.startdatetime || !this.duration) {
                    return
                }
                const start = dateJs2django( this.startdatetime ),
                    bookingData = {
                        resource: this.resource.id,
                        title: this.title,
                        start: start,
                        description: this.text,
                        creator: this.user.id
                    }
                this.createBooking(bookingData)
            },
            createBooking: function(payload) {
                this.errors = {}
                if (this.startdatetime && this.duration) {
                    let end_datetime = this.startdatetime.getTime()
                    end_datetime = end_datetime + this.duration.value
                    payload.end = dateJs2django( new Date(end_datetime) )

                    axios({
                        method: 'post',
                        url: '/booking/booking/',
                        data: payload,
                        headers: {
                            'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                        }
                    })
                    .then(res => {
                        notify(`Du har reserveret ${ res.data.resource_name }`, 'success')
                        this.$router.push('/my-bookings')
                        this.$store.commit('clearState')
                        this.$store.dispatch('fetchUserBookings')
                    })
                    .catch(err => {
                        Object.keys(err.response.data.detail).forEach((key,index) => {
                            Object.keys(err.response.data.detail[key]).forEach(k => {
                                this.errors[k] = err.response.data.detail[key][k]
                            })
                        })
                        this.$forceUpdate()
                        notify(`${ this.resource.name } kan ikke reserveres`, 'error')
                    })
                } else {
                    notify('Du skal angive starttid og varighed', 'error')
                }
            },
            fetchResourceTypeInfo: function(){
                if (this.resource) {
                    axios({
                        method: 'get',
                        url: `/booking/resourcetype/${ this.resource.resource_type }/`
                    })
                    .then(res => {
                        this.setLimitations(res.data.limitations)
                    })
                    .catch(err => console.log(err))
                }
            },
            setLimitations: function(limits) {

                // Set description field 'required' attribute based on resource type and user permissions
                for (let userlimitlist in limits) {
                    let approval_limit = limits[userlimitlist].find(function(e) {
                        return e.type === 'approvalrequirement'
                    })
                    if (approval_limit) {
                        this.limitations.approvalrequirement = true
                    }
                }

                // Set default title if this room doesn't demand approval and it does not have a title 
                if (!this.booking_title && !this.limitations.approvalrequirement) {
                    this.title = `Reservation af ${this.resource.name}`
                }
                
                // Set max duration if type has a max duration
                if (!this.user.is_staff) {
                    let duration_limit = limits.borger.find(function(e) {
                        return e.type === 'maxlengthofbookings'
                    })
                    if (duration_limit) {
                        // We are hardcoding a limit of 5 hours in milliseconds because there is no other way with current backend
                        this.limitations.limit_duration = 18000000
                    }
                }
            
            }
        },
        created: function() {
            this.title = this.booking_title
            this.text = this.purpose
            this.fetchResourceTypeInfo()
        }
    }

</script>

<style lang="scss">

    #createbooking {
        padding: 1rem;

        .input-group {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: flex-start;
            margin: 0 0 .5rem;

            input {
                margin: 0;
            }
            button {
                margin: 0 0 0 .5rem;
            }
        }
    }

</style>